import { Pipe, PipeTransform } from '@angular/core';
import { ReservationService } from '@/reservation/reservation.service';

@Pipe({
	name: 'currencyCode',
})
export class CurrencyCodePipe implements PipeTransform {
	constructor(private readonly reservationService: ReservationService) {}
	transform(currencyId: number): string {
		if (typeof currencyId !== 'number') throw new Error('Currency ID have to be a number!');
		return this.reservationService.getCurrencyCode(currencyId);
	}
}
